import Auth from "./utils/auth";
import Request from './utils/request';

export const auth = new Auth();

export const request = new Request(auth);